import { List } from "@dippi/ui";
import { Box, Link, ListItem, Modal, Typography, styled } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";

export const Styled = {
    GridToolbar: styled(GridToolbarContainer)`
        min-width: 960px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-height: 32px;
        padding: 0;
        margin-bottom: 24px;
    `,

    Modal: styled(Modal)`
        display: flex;
        justify-content: center;
        align-items: center;
    `,
    List: styled(List)`
        background-color: ${props => props.theme.palette.secondary.main};
        border: 2px solid ${props => props.theme.palette.secondary.light};
        border-radius: 12px;
        width: 800px;
        height: 420px;
    `,
    ListItem: styled(ListItem)`
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        margin: 10px 0px;
        transition: 0.2s ease-in;
        border-radius: 5px;
        padding: 2px 10px;
        &:hover {
            background-color: ${props => props.theme.palette.primary.main};
        }
        &:first-of-type {
            margin-top: unset;
        }
        &:last-of-type {
            margin-bottom: unset;
        }
    `,
    Link: styled(Link)`
        cursor: pointer;
        color: white;
    `,
    IconContainer: styled(Box)`
        min-width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        & svg {
            width: 32px;
        }
    `,
    Subtitle: styled(Typography)`
        color: darkgray;
    `,
};
